module.exports = __webpack_public_path__ + "img/stackslash-76.15f4e436.jpg";